<template>
  <Dialog
    title="编辑权限"
    :visible="visible"
    @close="handleClose"
    width="600px"
  >
    <Tree
      ref="tree"
      :data="data"
      :props="defaultProps"
      node-key="id"
      show-checkbox
      @check-change="handleCheckChange"
    >
      <span slot-scope="{ node }">
        <span>{{ node.label }}</span>
      </span>
    </Tree>

    <span slot="footer">
      <Button @click="cancel">取消</Button>
      <Button
        type="primary"
        @click="confirm"
      >
        确定
      </Button>
    </span>
  </Dialog>
</template>

<script>
import { Dialog, Tree, Button } from 'element-ui';

import requestMixin from './mixins/request';

export default {
  components: {
    Dialog,
    Tree,
    Button,
  },

  mixins: [requestMixin],

  props: {
    visible: {
      type: Boolean,
      default: false,
    },

    selected: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      data: [],
      defaultProps: {
        label: 'name',
      },
      perms: [],
    };
  },

  watch: {
    selected(newVal) {
      this.$refs.tree.setCheckedKeys(newVal);
    },
  },

  created() {
    this.getPermList();
  },

  methods: {
    handleCheckChange(data, checked, indeterminate) {
      // console.log(data, checked, indeterminate);
    },

    handleClose() {
      this.$emit('update:visible', false);
    },

    cancel() {
      this.handleClose();
    },

    confirm() {
      const arr = this.$refs.tree.getCheckedKeys();
      const arr1 = this.$refs.tree.getHalfCheckedKeys();
      const res = arr.concat(arr1);
      if (res.length < 1) {
        this.$message.error('请选择一个权限');
        return;
      }
      this.$emit('confirm', res);
      this.handleClose();
    },
  },
};
</script>